export default {
  organizationUser: "ORG",
  vendorUser: "VENDOR",
  patientUser: "PATIENT",
  internal_user: "INTERNAL_USER",
};
